var supportDescriptors = require('core-js/internals/descriptors');
var defineProperty = require('core-js/internals/object-define-property').f;
var NAME = 'toggle';
var proto = DOMTokenList.prototype;
function test(){
  var list = document.createElement("i").classList;
  list.toggle("a", false);
  return list.contains("a");// return true, force is ignored
}

// https://github.com/WebReflection/dom4/blob/f86fc053ad2d9f420d3bc7d295ed9ae906552f7d/src/dom4.js#L106-L117
// https://dom.spec.whatwg.org/#dom-domtokenlist-toggle
if (supportDescriptors && (!proto.hasOwnProperty(NAME)) || test()) {
  defineProperty(proto, NAME, {
    configurable: true,
    value: function(token, force) {
      if (this.contains(token)) {
        // force is not true (not given or false)
        if (!force) {
          this.remove(token);
          return false;
        }
        return true;
      }

      // not given or true
      if(force === undefined || force) {
        this.add(token);
        return true;
      }

      return false;
    }
  });
}
